exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-list[data-v-2dce32f6]{position:absolute;margin-left:0;list-style-type:none;display:block;z-index:9;min-width:200px;width:100%;font-size:10px;line-height:12px;padding:10px 0;text-align:left;background:#fff;border:2px solid #8593e9}@media only screen and (max-width:40em){.nav-list[data-v-2dce32f6]{position:fixed;margin-left:0;top:0;left:0;width:80vw;bottom:0;padding-right:60px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dce32f6","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/nav/private/SubList.vue
// module id = eebd7d49c887cdd502fe
// module chunks = 0